/**
 * Format raw stat-field values for the hover card.
 *
 * Currency and percentage metrics get a unit suffix; everything else uses a
 * compact decimal rendering that scales gracefully from 0.003 to 1.2M.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

const CURRENCY_IDS = new Set([
  'revenue',
  'cost',
  'profit',
  'epv',
  'epc',
  'epl',
  'uEPC',
  'uEPV',
  'cpc',
  'cpv',
  'ecpa',
  'ecpm',
  'rpm',
  'CPuC',
  'CPL',
  'CPS',
]);

const PERCENT_IDS = new Set([
  'roi',
  'ctr',
  'cr',
  'cv',
  'uctr',
  'ucr',
  'uCTR',
  'ImCTR',
  'Click2Reg',
  'Reg2Dep',
]);

const INTEGER_IDS = new Set([
  'impressions',
  'visits',
  'uniqueVisits',
  'clicks',
  'uniqueClicks',
  'conversions',
  'registrations',
  'ftd',
  'customConversions6',
  'customConversions7',
]);

export function fmtStatValue(id: string, value: number): string {
  if (!Number.isFinite(value)) return '—';
  if (PERCENT_IDS.has(id)) return formatPercent(value);
  if (CURRENCY_IDS.has(id)) return formatCurrency(value);
  if (INTEGER_IDS.has(id)) return formatInteger(value);
  return formatDecimal(value);
}

function formatPercent(value: number): string {
  return `${value.toFixed(value >= 100 || value <= -100 ? 0 : 2)}%`;
}

function formatCurrency(value: number): string {
  const abs = Math.abs(value);
  const digits = abs >= 1000 ? 0 : 2;
  return `${value < 0 ? '-' : ''}$${abs.toLocaleString(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })}`;
}

function formatInteger(value: number): string {
  return Math.round(value).toLocaleString();
}

function formatDecimal(value: number): string {
  const abs = Math.abs(value);
  if (abs >= 1000) return Math.round(value).toLocaleString();
  if (abs >= 10) return value.toFixed(2);
  return value.toFixed(3);
}
